<template>
    <div>
        <form v-on:submit="searchSubmit">
            <label for="search" class="sr-only">{{ $t('labels.search_button_label') }}</label>
            <div class="search-container">
                <input id="search" type="text"
                    ref="searchBox"
                    v-model="searchQuery"
                    @blur="hideSuggestions">
                <button type="submit" class="search-submit">
                    <span class="sr-only">{{ $t('labels.search_button_label') }}</span>
                </button>
                <!-- <div v-if="suggestions.length && displaySuggestions" 
                    class="suggestions"
                    @mouseenter="overSuggestions = true"
                    @mouseleave="overSuggestions = false">
                    <ul>
                        <li v-for="s in suggestions" :key="s">
                            <a :href="`/?${createUrlQuery({query: s})}`" class="search-toggle" exact>{{ s }}</a>
                        </li>
                    </ul>
                </div> -->
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: function() {
        return {
            searchQuery: null,
            displaySuggestions: false,
            overSuggestions: false
        }
    },
    computed: {
        ...mapGetters({
            'sort': 'search/sort',
            'order': 'search/order',
            'suggestions': 'search/suggestions',
        }),
    },
    watch: {
        '$route.query.q1': function (q) {
            if (q && q !== this.searchQuery) {
                this.urlSearch();   
            }
        },
        // 'searchQuery': function (q) {
        //     this.$store.dispatch('search/suggestions', {
        //         locale: this.$i18n.locale, query: q
        //     });
        //     this.displaySuggestions = true;
        // }
    },
    methods: {
        searchSubmit: function(event) {
            // only runs on form submission
            event.preventDefault()
            event.stopPropagation()

            this.$store.dispatch('list/clearSelected')

            let query = event.currentTarget.search.value;
            let data = {
                query: query,
                type: 'all',
                view: 'grid',
                page: 1,
                size: 24,
                order: 'asc',
                sort: 'title'
            }
            let queryString = this.createUrlQuery(data);
            data.urlString = queryString;

            data.query = ['all', '_contains', query];
            this.search(data, () => {
                this.$router.push(queryString);
            });
        },
        search (data, cb) {
            // runs on form submission and mounted
            this.$store.dispatch('search/update',  {
                locale: this.$i18n.locale,
                type: data.type,
                q: data.query,
                sort: data.sort,
                order: data.order,
                page: data.page,
                size: data.size,
                urlString: data.urlString,
                view: data.view
            }).then(() => {
                if (this.displaySuggestions) {
                    this.overSuggestions = false;
                    this.hideSuggestions();
                }

                if (cb) cb();
                this.$emit('loaded');
            })
        },
        hideSuggestions () {
            if (this.overSuggestions) return;
            this.displaySuggestions = false;
        },
        urlSearch () {
            if ("q1" in this.$route.query) {
                let data = this.$route.query;
                let query = decodeURI(data.q1).split('::');
                this.searchQuery = query.length > 1 ? query[2] : query[0];

                let exclude = ['sort','order','page','view', 'type','size']
                for (let key in data) {
                    if (!key.includes('q') && !exclude.includes(key)){
                        data[key].split('::').forEach(f => {
                            this.$store.dispatch('search/addFacet', {
                                name: key,
                                value: f
                            })
                        })
                    }
                }

                this.search({
                    type: data.type,
                    query: query,
                    sort: data.sort,
                    page: data.page,
                    size: data.size,
                    order: data.order,
                    view: data.view,
                    urlString: this.$route.fullPath.split('?')[1],
                });
            } else if (!Object.keys(this.$route.query).length) {
                this.$store.dispatch('results/clear');
            }
        },
        createUrlQuery(data) {
            let type = data.type || 'all';
            let query = data.query;
            let sort = data.sort || 'title';
            let order = data.order || 'asc';
            let view = data.view || 'grid';
            let size = data.size || 24;
            let page = data.page || 1;

            return `?type=${type}&q1=all::_contains::${query}&sort=${sort}&order=${order}&view=${view}&size=${size}&page=${page}`;
        },
        clearSearch: function(event){
            event.preventDefault()
            event.stopPropagation()
            this.searchQuery = '';
        }
    },
    async mounted() {
        this.$store.dispatch('search/searchType', 'basic');
        this.urlSearch();
    },
    async beforeRouteUpdate(to, from, next) {
        await this.urlSearch();
        next();
    }
}
</script>

<style scoped lang="scss">
.search-container {
    $searchbox-height: 74px;
    display: flex;
    margin-top: 1rem;
    position: relative;

    #search {
        flex-grow: 1;
        padding: .965rem;
        height: $searchbox-height;
        box-sizing: border-box;
        font-size: 2.25rem;
        font-weight: 500;
        color: $dark-gray1;
        border: $light-gray1 1px solid;
        text-transform: normal;
        width: 100%;
    
        &:focus, &:active {
            border: $light-gray1 1px solid;
            outline: none;
            box-shadow: 4px 4px 10px 0px #0000001A;
        }
    }

    .search-clear{
        cursor: pointer;
        position: absolute;
        top: 50%;
        margin-top: -0.781rem;
        right: 1.563rem;
        z-index: 1;
        border: 0 none;
        background: transparent;
        width: 1.25rem;
        height: 1.25rem;

        svg{
            width: 1.25rem;
            height: 1.25rem;
        }
    }
    
    .search-submit {
        flex-shrink: 0;
        height: $searchbox-height;
        width: $searchbox-height;
        background-color: $dark-gray1;
        border: none;
        outline: none;
        cursor: pointer;

        &:after {
            content: url('../assets/images/icon-arrow-go-white.svg');
            margin-left: -7px;
        }

        &:hover, &:focus {
            background: darken($dark-gray1, 12%);
        }
    }

    .suggestions {
        z-index: 3;
        position: absolute;
        top: $searchbox-height;
        background: $white;
        width: calc(100% - #{$searchbox-height});
        box-sizing: border-box;
        box-shadow: 4px 4px 10px 0px #0000001A;

        li:hover {
            background: rgba($light-gray1, .3);
        }

        a {
            color: $dark-gray1;
            font-size: 1.2rem;
            text-decoration: none;
            line-height: 2rem;
            padding: .5rem $s1;
            display: block;
            text-transform: capitalize;

        }
    }
}

</style>